import { Routes } from './routes';

export const BLACK_LIST_AUTH_BACKURL = [Routes.login, Routes.adminLogin];
